/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const getClassName = (error, displayError) => {
    if (error && displayError) {
        return 'rec-error';
    }
    return '';
};
